<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
</script>
<template>
    <div class="w-full items-center justify-between flex flex-wrap p-6">
        <div />
        <div>
            <p class="text-body-bold mb-3">
                {{ __('percentage-unit-from-avg') }}
            </p>
            <div class="min-w-50 w-126 grid grid-cols-7 gap-y-3">
                <div class="bg-sentiment-positive opacity-40 h-5" />
                <div class="bg-sentiment-positive-to-neutral opacity-40 h-5" />
                <div class="bg-sentiment-neutral-to-positive opacity-40 h-5" />
                <div class="bg-sentiment-neutral opacity-40 h-5" />
                <div class="bg-sentiment-neutral-to-negative opacity-40 h-5" />
                <div class="bg-sentiment-negative-to-neutral opacity-40 h-5" />
                <div class="bg-sentiment-negative opacity-40 h-5" />
                <div>
                    <p class="text-center text-body">0</p>
                </div>
                <div>
                    <p class="text-center text-body">1-5</p>
                </div>
                <div>
                    <p class="text-center text-body">6-15</p>
                </div>
                <div>
                    <p class="text-center text-body">16-25</p>
                </div>
                <div>
                    <p class="text-center text-body">25-30</p>
                </div>
                <div>
                    <p class="text-center text-body">31-40</p>
                </div>
                <div>
                    <p class="text-center text-body">>40</p>
                </div>
            </div>
        </div>
    </div>
</template>
